module.exports = __webpack_public_path__ + "static/media/password-confirm-button.a99d0a26.svg";